import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Homepage2 } from './components/Homepage2';
import { Homepage } from './components/Homepage';
import { MagicHomepage } from './components/MagicHomepage';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/home2" element={<Homepage2 data-id="element-17" />} data-id="element-16" />
        <Route path="/premium" element={<Homepage data-id="element-19" />} data-id="element-18" />
        <Route path="/magic" element={<MagicHomepage data-id="element-21" />} data-id="element-20" />
      </Routes>
    </BrowserRouter>;
}